<template>
  <div>
    {{ dateLabel }}
  </div>
</template>

<script>
import dateLabel from '@/mixins/dateLabel'

export default {
  mixins: [dateLabel],
  computed: {
    dateLabel() {
      const { month, year } = this.getDateLabel()

      return `${month.text} ${year}`.trim() // Апрель 2021
    },
  },
}
</script>
